<nav class="tg-nav" [class.scrolled]="scrolled">
  <div class="tg-nav__inner">

    <!-- Logo -->
    <a routerLink="/" class="tg-nav__logo">
      <img src="assets/img/logo.png" alt="TG Empleos" height="48">
    </a>

    <!-- Desktop links -->
    <ul class="tg-nav__links" *ngIf="!usuarioRol">
      <li><a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}">Inicio</a></li>
      <li><a routerLink="/vacantes" routerLinkActive="active">Vacantes</a></li>
      <li><a routerLink="/planes" routerLinkActive="active">Planes</a></li>
      <li><a href="https://tecgurus.net" target="_blank">Cursos</a></li>
      <li class="has-drop">
        <a>Consultoría <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2 4l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg></a>
        <ul class="tg-drop">
          <li><a href="https://portafolio.tecgurus.net/" target="_blank">Portafolio</a></li>
          <li><a href="https://www.expertosti.net/" target="_blank">Desarrollo de Apps</a></li>
          <li><a href="https://www.expertosti.net/" target="_blank">UI/UX</a></li>
        </ul>
      </li>
      <li><a routerLink="/contacto" routerLinkActive="active">Contacto</a></li>
    </ul>

    <ul class="tg-nav__links" *ngIf="usuarioRol == 'empresa'">
      <li><a routerLink="/empresa" routerLinkActive="active">Dashboard</a></li>
      <li><a routerLink="/candidatos" routerLinkActive="active">Candidatos</a></li>
      <li><a routerLink="/postulados" routerLinkActive="active">Postulados</a></li>
      <li class="has-drop">
        <a>Vacantes <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2 4l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg></a>
        <ul class="tg-drop">
          <li><a routerLink="/vacantes">Mis Vacantes</a></li>
          <li><a routerLink="/vacante/nuevo">Nueva Vacante</a></li>
        </ul>
      </li>
      <li><a routerLink="/editar-perfil" routerLinkActive="active">Mi Perfil</a></li>
    </ul>

    <ul class="tg-nav__links" *ngIf="usuarioRol == 'candidato'">
      <li><a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}">Inicio</a></li>
      <li><a routerLink="/vacantes" routerLinkActive="active">Vacantes</a></li>
      <li><a routerLink="/postulados" routerLinkActive="active">Postulaciones</a></li>
      <li><a routerLink="/mis-cvs" routerLinkActive="active">Mis CVs</a></li>
      <li><a routerLink="/mis-alertas" routerLinkActive="active">Alertas</a></li>
      <li><a routerLink="/mis-suscripciones" routerLinkActive="active">Suscripción</a></li>
      <li><a routerLink="/planes" routerLinkActive="active">Planes</a></li>
      <li><a routerLink="/editar-perfil" routerLinkActive="active">Mi Perfil</a></li>
    </ul>

    <!-- Actions -->
    <div class="tg-nav__actions">
      <ng-container *ngIf="!usuarioRol">
        <a routerLink="/acceder" class="tg-btn tg-btn--ghost">Acceder</a>
        <a routerLink="/registrarse" class="tg-btn tg-btn--primary">Registrarse</a>
      </ng-container>
      <ng-container *ngIf="usuarioRol">
        <div class="tg-nav__user">
          <img *ngIf="usuarioRol == 'candidato' && usuario.user.img" [src]="usuario.user.img" [alt]="usuario.user.nombre" class="tg-nav__avatar" (error)="onAvatarError($event)">
          <span class="tg-nav__name">{{ usuario.user.nombre }}</span>
        </div>
        <button class="tg-btn tg-btn--ghost" (click)="cerrarSesion()">Salir</button>
      </ng-container>
    </div>

    <!-- Mobile CTA: slogan izquierda + Ingresar derecha, llena el espacio entre logo y burger -->
    <div class="tg-nav__mobile-cta" *ngIf="!usuarioRol">
      <span class="tg-nav__slogan">La IA que encuentra<br>tu <strong>mejor empleo</strong></span>
      <a routerLink="/acceder" class="tg-btn tg-btn--primary tg-btn--sm" (click)="closeMenu()">Ingresar</a>
    </div>

    <!-- Hamburger -->
    <button class="tg-nav__burger" (click)="toggleMenu()" [class.open]="menuOpen" aria-label="Menú">
      <span></span><span></span><span></span>
    </button>
  </div>
</nav>

<!-- Spacer para que el contenido no quede bajo la nav fija -->
<div class="tg-nav__spacer"></div>

<!-- Mobile drawer — fuera del <nav> para evitar que backdrop-filter cree un stacking context que atrape el panel -->
<div class="tg-drawer" [class.open]="menuOpen" (click)="closeMenu()">
  <div class="tg-drawer__panel" (click)="$event.stopPropagation()">
    <div class="tg-drawer__head">
      <img src="assets/img/logo.png" alt="TG Empleos" height="36" style="background:#fff;">
      <button class="tg-drawer__close" (click)="closeMenu()">✕</button>
    </div>
    <ul class="tg-drawer__links" *ngIf="!usuarioRol">
      <li><a routerLink="/" (click)="closeMenu()">Inicio</a></li>
      <li><a routerLink="/vacantes" (click)="closeMenu()">Vacantes</a></li>
      <li><a routerLink="/planes" (click)="closeMenu()">Planes</a></li>
      <li><a href="https://tecgurus.net" target="_blank" (click)="closeMenu()">Cursos</a></li>
      <li class="tg-drawer__group-label">Consultoría</li>
      <li class="tg-drawer__sub"><a href="https://portafolio.tecgurus.net/" target="_blank" (click)="closeMenu()">Portafolio</a></li>
      <li class="tg-drawer__sub"><a href="https://www.expertosti.net/" target="_blank" (click)="closeMenu()">Desarrollo de Apps</a></li>
      <li class="tg-drawer__sub"><a href="https://www.expertosti.net/" target="_blank" (click)="closeMenu()">UI/UX</a></li>
      <li><a routerLink="/contacto" (click)="closeMenu()">Contacto</a></li>
    </ul>
    <ul class="tg-drawer__links" *ngIf="usuarioRol == 'empresa'">
      <li><a routerLink="/empresa" (click)="closeMenu()">Dashboard</a></li>
      <li><a routerLink="/candidatos" (click)="closeMenu()">Candidatos</a></li>
      <li><a routerLink="/postulados" (click)="closeMenu()">Postulados</a></li>
      <li><a routerLink="/vacantes" (click)="closeMenu()">Mis Vacantes</a></li>
      <li><a routerLink="/vacante/nuevo" (click)="closeMenu()">Nueva Vacante</a></li>
      <li><a routerLink="/editar-perfil" (click)="closeMenu()">Mi Perfil</a></li>
    </ul>
    <ul class="tg-drawer__links" *ngIf="usuarioRol == 'candidato'">
      <li><a routerLink="/" (click)="closeMenu()">Inicio</a></li>
      <li><a routerLink="/vacantes" (click)="closeMenu()">Vacantes</a></li>
      <li><a routerLink="/postulados" (click)="closeMenu()">Postulaciones</a></li>
      <li><a routerLink="/mis-cvs" (click)="closeMenu()">Mis CVs</a></li>
      <li><a routerLink="/mis-alertas" (click)="closeMenu()">Alertas</a></li>
      <li><a routerLink="/mis-suscripciones" (click)="closeMenu()">Suscripción</a></li>
      <li><a routerLink="/planes" (click)="closeMenu()">Planes</a></li>
      <li><a routerLink="/editar-perfil" (click)="closeMenu()">Mi Perfil</a></li>
    </ul>
    <div class="tg-drawer__footer">
      <ng-container *ngIf="!usuarioRol">
        <a routerLink="/acceder" class="tg-btn tg-btn--ghost w-100" (click)="closeMenu()">Acceder</a>
        <a routerLink="/registrarse" class="tg-btn tg-btn--primary w-100" (click)="closeMenu()">Registrarse</a>
      </ng-container>
      <ng-container *ngIf="usuarioRol">
        <p class="tg-drawer__username">{{ usuario.user.nombre }}</p>
        <button class="tg-btn tg-btn--ghost w-100" (click)="cerrarSesion()">Cerrar sesión</button>
      </ng-container>
    </div>
  </div>
</div>

<!-- Botones flotantes móvil (FAB bar) — encima del botón de WhatsApp -->
<div class="tg-fab-bar" *ngIf="!usuarioRol && !menuOpen">
  <a routerLink="/registrarse" [queryParams]="{role:'empresa'}" class="tg-fab tg-fab--blue">Empresas</a>
  <a routerLink="/acceder" [queryParams]="{returnUrl:'/mis-cvs'}" class="tg-fab tg-fab--green">Sube tu C.V.</a>
</div>
